let permissions = {}

const hasAnyPermission = (permissionsObject) => {
    let hasAnyPermission = false

    try {
        Object.keys(permissionsObject).forEach(key => {
            if (permissionsObject[key] === 'S') hasAnyPermission = true
        })
    } catch (error) {
        console.log(error.message)
    }

    return hasAnyPermission
}

const hasFilledPermissions = (permissionsObject) => {
    let hasFilledPermissions = false

    try {
        Object.keys(permissionsObject).forEach(key => {
            if (key !== 'token' && permissionsObject[key] != null) hasFilledPermissions = true
        })
    } catch (error) {
        console.log(error.message)
    }

    return hasFilledPermissions
}

const setPermissions = (permissionsObject) => {
    permissions = permissionsObject
}

const clearPermissions = () => {
    permissions = {}
}

const getPermission = (key) => {
    return permissions[key] === 'S'
}

const getOperator = () => {
    return permissions.operatorCode || ''
}

export default {
    setPermissions,
    clearPermissions,
    getPermission,
    hasAnyPermission,
    hasFilledPermissions,
    getOperator
}



// WEBPACK FOOTER //
// ./src/assets/controllers/AccessController.js